import DownloadIcon from "@mui/icons-material/Download";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaDeleteButton from "~/modules/app/components/GaiaDeleteButton";
import { getFileTypeIcon } from "~/modules/media/utils/mediaUtils";

import { MediaPreviewDialogFragment } from "./fragments.generated";

type Props = {
    media: MediaPreviewDialogFragment | null;
    open: boolean;
    onClose: () => void;
    onDelete?: (media: MediaPreviewDialogFragment) => void;
};

export default function MediaPreviewDialog({ media, open, onClose, onDelete }: Props) {
    const { t } = useTranslation("planner");
    if (!media) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
            <DialogTitle>{media.name || t("plannerMediaPreviewDialog.labelMediaPreview")}</DialogTitle>
            <DialogContent sx={{ padding: 0, display: "flex", minHeight: 0 }}>
                {media.mimeType.startsWith("image") && media.url ? (
                    <img src={media.url} style={{ width: "100%", maxHeight: "100%", objectFit: "contain" }} alt={media.name} />
                ) : (
                    <>
                        <IconButton>{getFileTypeIcon(media.mimeType)}</IconButton>
                        <Typography variant="body1">{media.name}</Typography>
                        <Typography variant="caption">{media.mimeType}</Typography>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                {media.url && (
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DownloadIcon />}
                        onClick={() => media.url && window.open(media.url, "_blank")}
                    >
                        {t("plannerMediaPreviewDialog.btnDownload")}
                    </Button>
                )}
                {onDelete && (
                    <GaiaDeleteButton
                        onDelete={async () => onDelete(media)}
                        label={t("plannerMediaPreviewDialog.btnDelete")}
                        isLoading={false}
                    />
                )}
                <Button onClick={onClose}>{t("plannerMediaPreviewDialog.btnClose")}</Button>
            </DialogActions>
        </Dialog>
    );
}
